import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Ai\GetAiUsageController::__invoke
* @see app/Http/Controllers/Ai/GetAiUsageController.php
* @route '/api/ai/usage'
*/
const GetAiUsageController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAiUsageController.url(options),
    method: 'get',
})

GetAiUsageController.definition = {
    methods: ["get","head"],
    url: '/api/ai/usage',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Ai\GetAiUsageController::__invoke
* @see app/Http/Controllers/Ai/GetAiUsageController.php
* @route '/api/ai/usage'
*/
GetAiUsageController.url = (options?: RouteQueryOptions) => {
    return GetAiUsageController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\GetAiUsageController::__invoke
* @see app/Http/Controllers/Ai/GetAiUsageController.php
* @route '/api/ai/usage'
*/
GetAiUsageController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAiUsageController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Ai\GetAiUsageController::__invoke
* @see app/Http/Controllers/Ai/GetAiUsageController.php
* @route '/api/ai/usage'
*/
GetAiUsageController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAiUsageController.url(options),
    method: 'head',
})

export default GetAiUsageController